import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Tag } from 'primereact/tag';
import { useRef } from 'react';
import styles from './Header.module.css';
import { GapSenseLogo } from '../icon/AppLogo';
import { ANALYSIS_ENABLED } from '@/config/features';

const Header = () => {
  const settingsRef = useRef<OverlayPanel>(null);

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <GapSenseLogo size="md" showText={true} animated={false} />
        {!ANALYSIS_ENABLED && (
          <Tag value="Demo" severity="secondary" className={styles.demoTag} />
        )}
      </div>
      <div className={styles.right}>
        <Button
          label="Export"
          icon="pi pi-download"
          className={styles.exportBtn}
          disabled={true}
        />
        <Button
          icon="pi pi-bell"
          className={styles.iconBtn}
          severity="secondary"
          outlined
          aria-label="Notifications"
          disabled={true}
        />
        <Button
          icon="pi pi-cog"
          className={styles.iconBtn}
          severity="secondary"
          outlined
          aria-label="Settings"
          onClick={(e) => settingsRef.current?.toggle(e)}
          disabled={true}
        />
        <OverlayPanel ref={settingsRef}>
          <div></div>
        </OverlayPanel>
        <Avatar
          icon="pi pi-user"
          size="large"
          shape="circle"
          className={styles.avatar}
        />
      </div>
    </header>
  );
};

export default Header;
